import { confirmAlert } from 'react-confirm-alert'
import { stringToSEO } from '../../src/utils/stringOps'

export const getHtmlForPdf = (isPortfolio, contentId, source) => {
  try {
    var iframeSearch = source == 'search' ? document.getElementById('iframe-search').contentWindow : ''

    var finalElement = document.createElement('div')
    finalElement.setAttribute('Id', 'divFinalPdf')
    finalElement.style.display = 'none;'
    var mainDiv = document.createElement('div')
    if (isPortfolio) {
      mainDiv.setAttribute('class', 'content-article portfolio')
    } else {
      mainDiv.setAttribute('class', 'content-article')
    }
    finalElement.appendChild(mainDiv)
    var aTagTitle = document.createElement('a')
   
    aTagTitle.innerHTML = source == 'search' ? iframeSearch.document.getElementsByClassName('article-title')[0].innerHTML
      : document.getElementsByClassName('article-title')[0].innerHTML
    aTagTitle.setAttribute('href', `/#/content/${contentId}/${stringToSEO(aTagTitle.innerHTML)}`)
    aTagTitle.style.fontSize = isPortfolio ? '16pt' : '18pt'
    aTagTitle.style.textDecoration = 'none'
    mainDiv.appendChild(aTagTitle)

    var pdfFileName = 'MLex | ' + aTagTitle.innerHTML

    var articlePublished = source == 'search' ? iframeSearch.document.getElementsByClassName('article-published')[0]
      : document.getElementsByClassName('article-published')[0]

    if (articlePublished != null) {
      var divArticlePublished = articlePublished.cloneNode(true)
      divArticlePublished.style.fontSize = isPortfolio ? '9pt' : '10pt'
      divArticlePublished.style.marginTop = '8pt'
      divArticlePublished.style.lineHeight = '24px'
      mainDiv.appendChild(divArticlePublished)
    }

    if (isPortfolio) {
      var gridContentCenter = source == 'search' ? iframeSearch.document.getElementsByClassName('grid-content-center')[0]
        : document.getElementsByClassName('grid-content-center')[0]

      var divContentCenter = gridContentCenter.cloneNode(true)
      divContentCenter.style.lineHeight = '18.4px'
      divContentCenter.style.fontSize = '9pt'
      divContentCenter.firstElementChild.style.fontSize = '10pt'
      divContentCenter.lastElementChild.style.marginTop = '30px'
      divContentCenter.lastElementChild.style.fontSize = '9pt'
      mainDiv.appendChild(divContentCenter)

      var gridContentAside = source == 'search' ? iframeSearch.document.getElementsByClassName('grid-content-aside')[0]
        : document.getElementsByClassName('grid-content-aside')[0]

      var divContentAside = gridContentAside.cloneNode(true)
      divContentAside.style.lineHeight = '18.4px'
      divContentAside.style.fontSize = '9pt'
      mainDiv.appendChild(divContentAside)
    } else {
      var articleAuthor = source == 'search' ? iframeSearch.document.getElementsByClassName('article-author')[0]
        : document.getElementsByClassName('article-author')[0]

      if (articleAuthor) {
        var divArticleAuthor = articleAuthor.cloneNode(true)
        divArticleAuthor.style.fontSize = '10pt'
        divArticleAuthor.style.lineHeight = '18px'
        divArticleAuthor.style.marginTop = '-2px'
        mainDiv.appendChild(divArticleAuthor)
      }

      var gridContentFull = source == 'search' ? iframeSearch.document.getElementsByClassName('grid-content-full')[0]
        : document.getElementsByClassName('grid-content-full')[0]

      var divContent = gridContentFull.cloneNode(true)
      divContent.style.lineHeight = '18.7px'
      divContent.style.fontSize = '10pt'
      divContent.firstElementChild.style.paddingLeft = '30px'
      divContent.firstElementChild.style.fontSize = '11pt'
      divContent.lastElementChild.style.marginTop = '30px'
      divContent.lastElementChild.style.fontSize = '10pt'
      mainDiv.appendChild(divContent)
    }

    finalElement.innerHTML = finalElement.innerHTML.replace(/\B\/#\/content/g, `${process.env.APP_BASE_URL}/#/content`)
    finalElement.innerHTML = finalElement.innerHTML.replace(/\B\/#\/search/g, `${process.env.APP_BASE_URL}/#/search`)

    return finalElement.innerHTML
  } catch (error) {
    document.getElementById('divDownloading').className = 'hide-loader'
    document.getElementById('divDownloaded').className = 'hide-loader'
    confirmAlert({
      title: 'PDF Download Failed',
      message: `Sorry, but we have encountered a problem downloading the selected result(s) to PDF.
Please re-try.  If the problem persists, please contact the MLex Customer Services (customerservices@mlex.com) and provide this error message.
      ${error.toString()}`,
      buttons: [
        {
          label: 'Close',
          onClick: () => { }
        }
      ]
    })

    throw error
  }
}
